module.exports = __webpack_public_path__ + "static/media/AM.12fefd50.svg";